export const Blogs = [
  {
    id: 1,
    name: "Google Summer of Code 2025 – Apache Lucene.NET Contributor & Official Committer",
    tags: ["Open Source", "Apache", "Lucene.NET"],
    date: "Sep 2025",
    imgSrc:
      "https://www.nexb.com/wp-content/uploads/2022/03/gsoc-sun-logo-new.png",
    link: "https://drive.google.com/file/d/1U3X2MR4SX-q6qYxaon5gsS4aOhBEvaBM/view",
  },
  {
    id: 7,
    name: "Full Stack Generative and Agentic AI with Python by Hitesh Choudhary and Piyush Garg",
    tags: ["AI", "Generative AI", "Python", "Full Stack"],
    date: "Apr 2026",
    imgSrc:
      "https://static.vecteezy.com/system/resources/previews/022/227/365/non_2x/openai-chatgpt-logo-icon-free-png.png",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-2065ca79-6dc0-493b-95ae-bfc58ea69cb9.jpg",
  },
  {
    id: 3,
    name: "ASP.NET Core by Harsha Vardhan (Web University)",
    tags: ["ASP.NET Core", "Backend"],
    date: "Feb 2025",
    imgSrc:
      "https://ih1.redbubble.net/image.366684650.5673/aps,504x498,small,transparent-pad,600x600,f8f8f8.u2.jpg",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-1f91f2fe-f62f-4c28-a39e-f27c6b5c7b81.jpg",
  },
  {
    id: 2,
    name: "Angular by Maximilian Schwarzmüller",
    tags: ["Angular", "Frontend"],
    date: "June 2024",
    imgSrc: "https://img.icons8.com/?size=900&id=j9DnICNnlhGk&format=png",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-035a15ac-9567-4f06-9c87-b4e803e767d2.jpg",
  },
  {
    id: 6,
    name: "C++ by Dr. Frank Mitropoulos",
    tags: ["C++", "Programming"],
    date: "Jan 2024",
    imgSrc: "https://img.icons8.com/?size=900&id=40669&format=png",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-62f9371a-efb8-4b71-bc34-691a724f9a8d.jpg",
  },
  {
    id: 4,
    name: "HTML & CSS by Jonas Schmedtmann",
    tags: ["HTML", "CSS", "Frontend Basics"],
    date: "Jan 2024",
    imgSrc: "https://img.icons8.com/?size=900&id=20909&format=png",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-920ad53b-b3a8-40cc-80b5-9bc69798fd70.jpg",
  },
  {
    id: 5,
    name: "C Language by Vlad Budnitski",
    tags: ["C", "Programming"],
    date: "Dec 2022",
    imgSrc: "https://img.icons8.com/?size=900&id=mfkStOwP4EC0&format=png",
    link: "https://udemy-certificate.s3.amazonaws.com/image/UC-ce034b1a-d4f1-4f05-afe7-96a064c2125f.jpg",
  },
];
